/**
 * Full reload after the active organization changes, so every store, query and
 * socket starts fresh for the new org. Detail pages may not exist in the new org,
 * so they fall back to their list page.
 */
export function reloadAfterOrgSwitch() {
  const pathname = window.location.pathname;

  if (/^\/chat\/[^/]+/.test(pathname)) {
    window.location.assign('/chat');
  } else if (pathname.startsWith('/agent-details')) {
    window.location.assign('/agents');
  } else if (pathname.startsWith('/knowledge-base')) {
    window.location.assign('/knowledge-base');
  } else {
    window.location.reload();
  }
}
